module.exports = __webpack_public_path__ + "static/media/code-merge.bf627088.svg";